import React from 'react';
import { Layout, Spin } from 'antd';

import menuList from "./menulist.js"
import Menu from "./menu.js"
import Head from './head.js';
import Intro from './intro.js';
import common from '../assets/common.js';
//import logo from '../images/logo.svg';
import logo from '../images/rabbit.png';
import police from '../images/police.png';
//import logoL from '../images/logo-l.svg';
import logoL from '../images/rabbit-l.png';
import './index.css';
const { Content, Sider, Footer } = Layout;
class Body extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      admin : {},
      loading : false,
      collapsed : false,
      superAdmin : false,
      superAdminButton : false,
      org : ''
    }
  }
  componentWillMount(){
    const menu = this.props.location.pathname;
    var parents = common.lookUpParent(menuList.list, "sub", "key", menu)[0];
    if(!parents) {

    }
    if(!window.location.hash.split("#/")[1].includes("login") && !window.location.hash.split("#/")[1].includes("super")) {
      this.getMe();
      this.organization();
    }
  }
  componentWillReceiveProps(){

  }
  // 检查是否是超管
  organization = () => {
    var postData = {};
    postData["_url"] = "api/organization";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data){
      obj.setState({
        superAdminButton: data.result.superAdmin,
        org: data.result
      });
    })
  }
  // 查看是否是管理员
  getMe = () => {
    var postData = {};
    postData["_url"] = "api/admin/me";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data){
      obj.setState({
        superAdmin: data.result.superAdmin,
        subAdmin: data.result.subAdmin
      });
      sessionStorage.setItem("subAdmin",data.result.subAdmin);
    })
  }
  changeCollapsed = (collapsed) => {
    this.setState({
      openKeys : []
    }, function(){
      setTimeout(this.setState({ collapsed }) ,1000)
    })
  }
  toIndex = () => {
    const menu = this.props.location.pathname;
    if(menu) {
      this.props.history.push("/overview")
    }
  }
  render() {
    const { loading, collapsed, info, superAdmin, subAdmin, superAdminButton, org } = this.state;
    const menu = this.props.location.pathname;
    const history = this.props.history;
    var parents = common.lookUpParent(menuList.list, "sub", "key", menu)[0];
    var sub = "";
    if(!parents) {
      return <div></div>
    } else {
      var menuKey = parents[0];
      window.menu = menu;
      window.path = menuKey.key;
      sub = React.createElement(menuKey.content, {
        menu : menu,
        history : history,
        parent : menuKey.key
      })
    }
    var main = <div></div>;
    const body = (<Content id="contentDesc">
      {
        loading ?
        <Spin/> :
        <div id="mainContent" className="relative">
          { sub }
        </div>
      }
      <Footer id="footerMessage" className="text-center">   Copyright © 2012 - 2026 Yunban. All Rights Reserved. <a href="https://www.yunban.com">云瓣科技有限公司</a>版权所有 沪ICP备14019811号-2 <a style={{color: "rgba(0,0,0,.45)"}} href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013871" target="_blank">沪公网安备 31011502013871号<img className="police" src={ police }/></a></Footer>
    </Content>);
    const head = (
      <Sider
        id="menuSlider"
        collapsed={ collapsed }
        onCollapse={ this.onCollapse }
        width="240px"
      >
        {/*
          <div id="logoDiv" className="cursor-pointer" onClick={ this.toIndex }>
            { collapsed ?
              <img src={ logo } height="28px"  alt="logo"/> :
              <img src={ logoL } height="28px" alt="logo" />
            }
          </div>
          */}
        <div id="logoDiv" className="cursor-pointer" onClick={ this.toIndex }>
          { collapsed ?
            <img src={ logo } height="40px"  alt="logo"/>:
            <img src={ logoL } height="52px" alt="logo" />
          }
        </div>
        <Menu collapsed={ collapsed } menu={ menu } info={ info } history={ history } superAdmin={ superAdmin } subAdmin={ subAdmin }/>
      </Sider>
    )
    switch(menu){
      case "/404":case "/403":case "/500":
        main = true ? <Layout id="mainLayout">
          { head }
          <Layout id="contentLayout" className={ collapsed ? "collapsed hasHead" : "nocollapsed hasHead" }>
            <Head changeCollapsed={ this.changeCollapsed.bind(this) } collapsed={ collapsed } history={ history } superAdminButton={ superAdminButton } org={org}/>
            <Layout id="subLayout">
              { body }
            </Layout>
          </Layout>
        </Layout> :
        <div></div>
        break;
      case "/login":
        main = sub
        break;
      case "/super":
        main = sub
        break;
      default:
        main = true ? <Layout id="mainLayout">
          { head }
          <Layout id="contentLayout" className={ collapsed ? "collapsed hasHead" : "nocollapsed hasHead" }>
            <Head changeCollapsed={ this.changeCollapsed.bind(this) } collapsed={ collapsed } history={ history } superAdminButton={superAdminButton} org={org}/>
            <Layout id="subLayout">
              { body }
            </Layout>
          </Layout>
        </Layout> :
        <div></div>
        break;
    }
    return main
  }
}

export default Body;



// WEBPACK FOOTER //
// ./src/index/main.js